export default __webpack_public_path__ + "static/media/surface.32e37c47.svg";